import { isSmallScreen } from "../../../helpers/screens";
import FeaturesBox from "./FeaturesBox";

const FeaturesCards = () => {
    return (
        <div className={`relative`} >
            <FeaturesBox />
        </div>
    )
}

export default FeaturesCards;